import React from 'react'

import { Item, Box } from 'react-html-email';

import Row from "./row";

const IfComponent = ({ content, section, parentIndex, html }) => {
    const conditionList = content.config.condition && content.config.condition.split(',');

    const ifCondtionString = conditionList.reduce((acc, condition, currentIndex, array) => {
        return acc + `<!--[#if ${condition}]-->`;
    }, '');

    const endIfCondtionString = conditionList.reduce((acc, condition, currentIndex, array) => {
        return acc + `<!--[/#if]-->`;
    }, '');

    return (
        <React.Fragment>
            <span dangerouslySetInnerHTML={{
                __html: ifCondtionString
            }}></span>
            <Box>
                {content.config.if.content.map((ifContent, index) => (
                    <Item key={index} align={content.align}>
                        <Row
                            content={ifContent}
                            section={`${section}_${parentIndex}_if`}
                            index={index}
                            html={html}
                        />
                    </Item>
                ))}
            </Box>
            <span dangerouslySetInnerHTML={{
                __html: endIfCondtionString
            }}></span>
        </React.Fragment>
    );
};

export default IfComponent;
